var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tooltip",class:`tooltip--${this.position}`,style:({ minWidth: _vm.minWidth }),attrs:{"id":_vm.id}},[_c('span',[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }